const FH_INDEX = 4
const WN_INDEX = 7

const r_0 = '投保人在保单犹豫期后解除合同会遭受一定损失，具体保单利益请以保单合同为准。'
const r_1 = '上述所有利益演示均基于保险公司的假设，不代表该公司的历史经营业绩和对未来经营业绩的预期。'
const r_2 = '保单的红利分配是不确定的，实际红利金额根据分红保险业务实际经营情况决定。'
const r_3 = '万能保险的最低保证利率之上的投资收益是不确定的，实际保单账户利益可能低于中、高档利益演示水平。'
// const r_4 = '温馨提示：以上演示说明为本平台对上述产品的理解，便于保险从业人员学习、交流，演示数据仅供参考，请以实际为准。'
const r_4 = '温馨提示：本计划书非保险销售宣传资料，仅供保险从业人员学习、交流使用，不得用于任何商业用途；计划书不构成投保任何保险的依据，亦不构成投保任何保险的要约或要约邀请。'

const riskContent = (typeList, insTypeOrder) => {
  let result = []

  const fhIndex = insTypeOrder.indexOf(FH_INDEX)
  const wnIndex = insTypeOrder.indexOf(WN_INDEX)
  const fh = typeList[fhIndex]
  const wn = typeList[wnIndex]

  if (fh) {
    result.push(r_2)
  }
  if (wn) {
    result.push(r_3)
  }
  if (fh || wn) {
    result.unshift(r_1)
  }
  result.unshift(r_0)
  result.push(r_4)

  return result
}

export default riskContent